import { get, post } from '@/utils/request';

export const SaveContract = (params) => {
  return post('/api/v1/save_contract', params);
};

export const GgbTemp = (name) => {
  return get(`/api/v1/ggb_temp/${name}`);
};
